/*
 * VESPER LUNA — Contact page enhancements
 *
 * Progressive enhancement only. Form submission stays native — we never
 * call preventDefault on submit, never touch the KVKK required attribute,
 * never intercept the Shopify POST.
 *
 * Features:
 *   - textarea auto-grow for [data-vl-textarea-autogrow]
 *   - autofocus on first error / success banner already handled inline
 */

(function () {
  'use strict';

  function autoGrow(textarea) {
    if (!textarea) return;
    var minHeight = textarea.scrollHeight;
    var cssMin = parseFloat(window.getComputedStyle(textarea).minHeight) || 0;
    minHeight = Math.max(minHeight, cssMin);

    function resize() {
      textarea.style.height = 'auto';
      var next = Math.max(textarea.scrollHeight, minHeight);
      textarea.style.height = next + 'px';
    }

    textarea.addEventListener('input', resize);
    resize();
  }

  function init() {
    var textareas = document.querySelectorAll('[data-vl-textarea-autogrow]');
    for (var i = 0; i < textareas.length; i++) {
      autoGrow(textareas[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
